import React, { useState, useEffect } from "react";
import * as Style from "./styledComponents/PersonalInstruction";
import Safe from "../assets/images/DeathModuleNew/Etherium-3.png";
import SeeMore from "../assets/images/DeathModuleNew/more_horiz.png";
import TitleImg from "../assets/images/DeathModuleNew/Rectangle 34624117.png";

import menuIcon from "../assets/images/DeathModuleNew/Menu.png";
import List from "./styledComponents/Table/List";
import { Modal } from "antd";
import AddModal from "./styledComponents/Modal/AddModal";
import UpdateModal from "./styledComponents/Modal/UpdateModal";
import helpIcon from "../assets/images/DeathModuleNew/IC_Help.png";
import Loader from "../components/styled-components/loader/loader";
import DEATH_API from "../apis/death.api";
import MODULE_API from "../apis/module.api";
import ViewModal from "./styledComponents/Modal/ViewModal";

import swal from "sweetalert";
import axios from "axios";
import { ToolTipCreator } from "../helpers/ToolTipCreator";

export const LitigationList = (props) => {
  const [tooltipModal, setTooltipModal] = useState(false);
  const [litigationList, setLitigationList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dropdown, setDropdown] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [addData, setaddData] = useState({});
  const [updateObject, setUpdateObject] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const handelCloseViewModal = () => {
    setShowViewModal(false);
  };
  const cols = [
    {
      title: "Litigation Name",
      dataIndex: "name",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Potential Liability",
      dataIndex: "liability",
      render: (record) =>
        record
          ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
          : "N/A",
    },
    {
      title: "Are We Likely To Win?",
      dataIndex: "result",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "File",
      dataIndex: ["fileName", "fileUrl"],
      // render: (record) => (record ? record : "N/A"),
      render: (fileName, record) => {
        return record.fileUrl ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            {" "}
            <a
              style={{ color: "#7d8fb3" }}
              href={record.fileUrl}
              target="blank">
              {" "}
              {record.fileName}
            </a>
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Notes",
      dataIndex: "note",
      render: (record) => (record ? record : "N/A"),
    },

    {
      title: "Action",
      render: (record, index) => {
        // console.log("index...>>>",record.idx);
        return (
          <div>
            <div
              onClick={() => {
                setDropdown(!dropdown);
                getSelectedRow(record.id);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "0px 16px",
                width: "5px",
              }}>
              <img src={menuIcon} alt="menuIcon"></img>
            </div>
            {dropdown && selectedIndex === record.id && (
              <>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}></div>

                <div class="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    {props.role !== "protrustee" && (
                      <li
                        className="liHover"
                        onClick={() => {
                          deleteSelectedRow(record.id);
                          setDropdown(false);
                        }}>
                        Delete
                      </li>
                    )}
                    {props.role !== "protrustee" && (
                      <li
                        className="liHover"
                        onClick={() => {
                          setShowUpdateModal(true);
                          setDropdown(false);
                        }}>
                        Update
                      </li>
                    )}
                    <li
                      className="liHover"
                      onClick={() => {
                        setShowViewModal(true);
                        setDropdown(false);
                      }}>
                      View
                    </li>
                  </ul>
                </div>
              </>
            )}{" "}
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    console.log("calling api");
    getLitigationList();
  }, []);
  const getLitigationList = async () => {
    try {
      (async () => {
        setLoading(true);
        const ID = localStorage.getItem("accessId");

        let data = await DEATH_API.fetchLitigation(ID);
        setLoading(false);
        if (data && data.data) {
          setLitigationList(data.data);
        }
      })();
    } catch (error) {
      console.log(error);
      setLoading(false);
      // this.props.handleLoader();
    }
  };

  const showTooltipModal = () => {
    setTooltipModal(true);
  };

  const handleTooltipCancel = () => {
    setTooltipModal(false);
  };
  const handlechange = (e) => {
    console.log("e", e.target);
    e.preventDefault();
    const { name, value } = e.target;

    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleCurrencychange = (e) => {
    console.log("e", e.target);
    e.preventDefault();
    const { name, value } = e.target;
    const inputString = e.target.value;
    const convertedNumber = parseFloat(inputString.replace(/,/g, ""));

    setaddData({
      ...addData,
      [name]: convertedNumber,
    });
  };
  const handleUpdateCurrencychange = (e) => {
    console.log("e", e.target);
    e.preventDefault();
    const { name, value } = e.target;
    const inputString = e.target.value;
    const convertedNumber = parseFloat(inputString.replace(/,/g, ""));
    setUpdateObject({
      ...updateObject,
      [name]: convertedNumber,
    });
  };
  const handleDocumentChange = (name, value) => {
    // console.log("e", e.target);
    // e.preventDefault();
    // const { name, value } = e.target;

    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleDatePickerChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleRadioChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleUpdatechange = (e) => {
    console.log("e", e.target);
    e.preventDefault();
    const { name, value } = e.target;

    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateDocumentChange = (name, value) => {
    // console.log("e", e.target);
    // e.preventDefault();
    // const { name, value } = e.target;

    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateDatePickerChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateRadioChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const SubmitUpdate = () => {
    console.log("updated object submit", updateObject);
    updateLitigation();
    handelCloseUpdateModal();
  };
  const submitData = () => {
    console.log("submit data", addData);
    createLitigation();
    handelCloseModal();
  };
  const handelCloseModal = () => {
    console.log("cloing modal", addData);
    setaddData({});
    setShowModal(false);
  };
  const handelCloseUpdateModal = () => {
    setShowUpdateModal(false);
  };
  const getSelectedRow = (idx) => {
    console.log("idx", idx);
    setSelectedIndex(idx);
    // get selected row (this will return array of object)
    let selectedRow = litigationList.filter((row, index) => {
      return row.id == idx;
    });

    // get first and only element from list and store it in update object
    console.log("selectedRow", selectedRow[0]);
    setUpdateObject(selectedRow[0]);
  };
  const createLitigation = async (currentFormData) => {
    // check if already formData contains some data then initialize it with empty

    var arr = [addData];
    try {
      let data = arr;
      if (Array.isArray(data) && data.length > 0) {
        const allPromises = data.map(async (item) => {
          if (item.Upload) {
            const formData = new FormData();
            formData.append("file", item.Upload);
            console.log("item.file", item.Upload);
            const name = item.Upload.name;
            const lastDot = name.lastIndexOf(".");
            const fileName = name.substring(0, lastDot);
            const ext = name.substring(lastDot + 1);
            const resdata = await MODULE_API.uploadFile({
              fileExt: ext,
              contentType: item.Upload.type,
            });
            const resupload = await axios.put(resdata.uploadUrl, item.Upload, {
              headers: { "Content-type": item.Upload.type },
            });
            const res = resdata.uploadUrl.split("?")[0];
            console.log(res);
            delete item.Upload;
            return { ...item, fileUrl: res, uploaded: name };
          }
          return item;
        });
        // this.props.handleLoader()
        setLoading(true);
        let res = await Promise.all(allPromises);
        console.log("res>>> litigation", res);
        let api_res = await DEATH_API.addLitigation({
          litigationForm: res.map((item) => {
            let result = null;
            if (
              item.PotentialWinLoss &&
              typeof item.PotentialWinLoss === "string"
            ) {
              result = item.PotentialWinLoss && item.PotentialWinLoss;
            }
            return {
              name: item["Litigation Nickname"],
              liability: +item["Potential Liability"],
              result,
              note: item.Notes,
              fileUrl: item.fileUrl,
              fileName: item.uploaded,
            };
          }),
        });
        setLoading(false);
        // this.props.handleLoader()

        getLitigationList();
        return api_res;
      }
    } catch (error) {
      console.log(error);
      throw new Error(error);
    }
  };
  const updateLitigation = async () => {
    try {
      // this.props.handleLoader()
      setLoading(true);
      let result = false;
      if (updateObject.result && typeof updateObject.result === "string") {
        result = updateObject.result && updateObject.result;
      }
      let uploaded = {};

      console.log("this.state.updateObject.Upload", updateObject.Upload);
      if (updateObject.Upload) {
        const formData = new FormData();
        formData.append("file", updateObject.Upload);

        const name = updateObject.Upload.name;
        const lastDot = name.lastIndexOf(".");
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        const resdata = await MODULE_API.uploadFile({
          fileExt: ext,
          contentType: updateObject.Upload.type,
        });
        const resupload = await axios.put(
          resdata.uploadUrl,
          updateObject.Upload,
          { headers: { "Content-type": updateObject.Upload.type } }
        );
        const res = resdata.uploadUrl.split("?")[0];
        console.log("resss file url", res);
        uploaded.file_url = res;
        uploaded.fileName = name;
      }
      let obj = {
        ...updateObject,
        name: updateObject["Litigation Nickname"],
        liability:
          +updateObject["Potential Liability"] ||
          +updateObject["liability"] ||
          null,
        result,
        note: updateObject.note,
        fileName: uploaded
          ? uploaded.fileName
          : updateObject.Upload.name
          ? updateObject.Upload.name
          : "",
        fileUrl: uploaded
          ? uploaded.file_url
          : updateObject.fileUrl
          ? updateObject.fileUrl
          : "",
      };
      delete obj.Upload;
      console.log("obj in playload update", obj);
      await DEATH_API.updateLitigation(obj.id, obj);
      setLoading(false);

      getLitigationList();
      setUpdateObject(null);
    } catch (error) {
      console.log("error in update", error);
      setLoading(false);
      // this.props.handleLoader();
    }
  };
  const deleteSelectedRow = async (idx) => {
    // var that = this;
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        // that.props.handleLoader()
        try {
          // const { litigation_list } = that.state
          // that.props.handleLoader()
          setLoading(true);
          await DEATH_API.deleteLitigation(idx);
          setLoading(false);
          // that.props.handleLoader()
          const updatedRows = litigationList.filter((row, index) => {
            return row.id != idx;
          });
          setLitigationList(updatedRows);
          getLitigationList();
        } catch (error) {
          console.log("error deleting Personal Instruction");
          console.log(error);
        }
        setTimeout(async () => {
          // that.props.handleLoader()
          setLoading(true);
          swal("Deleted!", "Your file has been deleted.", "success");
          setLoading(false);
          // that.props.handleLoader()
        }, 0);
      } else {
        swal("Cancelled", "Your file is safe :)", "error");
      }
    });
  };
  const fields = [
    {
      title: "Litigation Nickname",
      type: "input",
      index: "LitigationNickname",
    },
    {
      title: "Potential Liability",
      type: "currency",
      index: "PotentialLiability",
    },
    {
      title: "Are We Likely To Win?",
      type: "radio1",
      index: "PotentialWinLoss",
    },

    {
      title: "Upload",
      type: "file",
      index: "Upload",
    },
    {
      title: "Notes",
      type: "textarea",
      index: "Notes",
    },
  ];

  const update_fields = [
    {
      title: "Litigation Nickname",
      type: "input",
      index: "name",
    },
    {
      title: "Potential Liability",
      type: "currency",
      index: "liability",
    },
    {
      title: "Are We Likely To Win?",
      type: "radio1",
      index: "result",
    },

    {
      title: "Upload",
      type: "file",
      index: "fileUrl",
    },
    {
      title: "Notes",
      type: "textarea",
      index: "note",
    },
  ];
  return (
    <div>
      {" "}
      <Modal
        centered
        visible={tooltipModal}
        footer={null}
        onCancel={handleTooltipCancel}>
        <Style.ModalTitle> Litigation</Style.ModalTitle>
        <div style={{}}>
          <div className="">
            <Style.ModalDetails>
              Litigation List is not applicable to each person that dies but
              having the ability to convey details of pending litigation might
              be very beneficial to those the Plan Creator leaves behind. If the
              person that died spent years fighting for their day in court, then
              they would want those left behind to gain access to the maximum
              amount of information, so that they can pursue the case to benefit
              those chosen by the Plan Creator. Knowing that a Plan Creator is
              not losing a litigation case because they didn’t share notes and
              details is an honest comfort for many people as it addresses the
              need to not feel like a victim. The opposite can also be true if
              the Plan Creator is in litigation against them, and they would
              want the maximum information available to the Trusted Individuals
              so that they can find ways to protect the estate in civil court.
            </Style.ModalDetails>
          </div>
        </div>
      </Modal>
      {showModal && (
        <AddModal
          show={showModal}
          close={handelCloseModal}
          fields={fields}
          modalTitle="Add New Litigation"
          handlechange={handlechange}
          handleCurrencychange={handleCurrencychange}
          submitData={submitData}
          handleDocumentChange={handleDocumentChange}
          handleDatePickerChange={handleDatePickerChange}
          handleRadioChange={handleRadioChange}
        />
      )}
      {showUpdateModal && (
        <UpdateModal
          show={showUpdateModal}
          close={handelCloseUpdateModal}
          fields={update_fields}
          modalTitle="Update Litigation"
          handlechange={handleUpdatechange}
          handleUpdateCurrencychange={handleUpdateCurrencychange}
          submitData={SubmitUpdate}
          handleDocumentChange={handleUpdateDocumentChange}
          handleDatePickerChange={handleUpdateDatePickerChange}
          handleRadioChange={handleUpdateRadioChange}
          obj={updateObject}
        />
      )}
      {showViewModal && (
        <ViewModal
          show={showViewModal}
          close={handelCloseViewModal}
          fields={update_fields}
          modalTitle="View Litigation"
          obj={updateObject}
        />
      )}
      <Style.MainHeading>
        {/* <Style.HeaderImg src={Safe} alt="Safe"></Style.HeaderImg> */}
        <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
          Litigation{" "}
          <ToolTipCreator name={"Death_Litigation"}/>
        </div>
        {/* <Style.HelpIcon
          src={helpIcon}
          alt="helpicon"
          onClick={() => {
            showTooltipModal();
          }}></Style.HelpIcon> */}
      </Style.MainHeading>
      <Style.HealthCard>
        <Style.HealthCardHeader>
          <Style.Title style={{}}>Litigation</Style.Title>
          {props.role !== "protrustee" && (
            <div>
              <Style.Button
                onClick={() => {
                  setShowModal(true);
                }}>
                +
              </Style.Button>
            </div>
          )}
        </Style.HealthCardHeader>
        <List cols={cols} rows={litigationList}></List>
      </Style.HealthCard>
      <Loader isLoading={loading} />
    </div>
  );
};
